import { render, staticRenderFns } from "./OnboardingVerificationComplete.vue?vue&type=template&id=01e7da78&"
import script from "./OnboardingVerificationComplete.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerificationComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports